import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import BuildCircle from '@mui/icons-material/BuildCircle';
import Assignment from '@mui/icons-material/Assignment';
import Speed from '@mui/icons-material/Speed';
import { usePortalAuthContext } from '../../contexts/portalAuth';
import { PORTAL_SECTIONS } from './portalSections';
import styles from './portal.module.css';

// Keyed by section path so the nav and each screen's own heading agree.
const PORTAL_SECTION_ICONS: Record<string, typeof BuildCircle> = {
  report: BuildCircle,
  jobs: Assignment,
  counters: Speed,
};

export const PortalNav = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasModule } = usePortalAuthContext();

  const sections = PORTAL_SECTIONS.filter((section) => hasModule(section.module));

  // With a single section there is nothing to switch between, so the tab bar
  // would just be chrome.
  if (sections.length < 2) return null;

  const activeIndex = sections.findIndex((section) =>
    location.pathname.includes(`/${section.path}`)
  );

  return (
    <Box className={styles.nav}>
      <Box className={styles.navInner}>
        <Tabs value={activeIndex >= 0 ? activeIndex : 0} variant="scrollable" scrollButtons="auto">
          {sections.map((section) => {
            const SectionIcon = PORTAL_SECTION_ICONS[section.path];
            return (
              <Tab
                key={section.path}
                icon={SectionIcon ? <SectionIcon fontSize="small" /> : undefined}
                iconPosition="start"
                label={t(section.label)}
                onClick={() => navigate(section.path)}
                sx={{ minHeight: 56, textTransform: 'none', fontWeight: 600 }}
              />
            );
          })}
        </Tabs>
      </Box>
    </Box>
  );
};
